import React from 'react';
import {Typography, Grid} from '@mui/material';
import SplashSwoosh from './SplashSwoosh';
import styled from '@emotion/styled';
import logo from '../../assets/images/griffith-logo.png';
import hero from '../../assets/images/splash-hero-right.png';

export default function SplashHero() {
  const Container = styled.div(props => ({
    background: '#fafafa',
    lineHeight: 0,
  }))

  let GLOBAL_SPLASH_LINK = "https://flavoriq.miron.services";
  if (window.location.hostname==="conceptlocker.flavoriq.global") GLOBAL_SPLASH_LINK = "https://flavoriq.global";
  
  return (
    <main>
      <Container maxWidth="xl" disableGutters>
        <Grid container>
          <Grid item xs={1}>&nbsp;
          </Grid>
          <Grid item xs={6}>
            <div className="hero">
            <a href={GLOBAL_SPLASH_LINK}><img src={logo} alt="Griffith Foods" className='hero--logo'/></a>
              <Typography
                variant="h1"
                className="hero--headline"
                sx={{mt: 5, mb: 1}}
              >
                <em>
                GRIFFITH FOODS CONCEPTS — <br/>Which made it to market?
                </em>
              </Typography>
              <SplashSwoosh />
              <br/>

              <Typography
                variant="body2"
                sx={{mt: 3}}
                className="hero--desc"
              >
                Explore Griffith Foods ingredients that have made it into products, and 
                <br/>onto menus, and store shelves around the globe.
              </Typography>
            </div>
          </Grid>
          <Grid item xs={5}>
            <img src={hero} alt="hero" className="hero--right"/>
          </Grid>
        </Grid>


      </Container>
    </main>
  )
}
